import humps from 'humps';

import moment from 'moment';

import _get from 'lodash/get';
import omit from 'lodash/omit';

import Auth, { setProfile } from 'app/utils/Auth';

import flattenDeep from 'lodash/flattenDeep';

import { toastr } from 'react-redux-toastr';

import * as fetchUtils from 'app/utils/FetchUtils';
import { objectToFormData } from 'app/utils/CommonUtils';
import { getActiveEntityId, getActiveUserId, getActiveUser } from 'app/actions/AuthedActions';
import { NOTIFICATION_CHANNELS, PRODUCT_ID, PRODUCT_ID_CREDIT } from 'app/constants/Constants';

const initialState = {
    isFetching: false,
    switchUsersList: null,
    actorsAndRoles: [],
    credpoolRoles: [],
};

// actions
const createActionName = (name) => `app/entities/${name}`;
export const FETCHING_DATA = createActionName('FETCHING_DATA');

export const ENTITY_LIST_SUCCESS = createActionName('ENTITY_LIST_SUCCESS');
export const SWITCH_LIST_SUCCESS = createActionName('SWITCH_LIST_SUCCESS');
export const ENTITY_FETCH_SUCCESS = createActionName('ENTITY_FETCH_SUCCESS');
export const ENTITY_ADD_SUCCESS = createActionName('ENTITY_ADD_SUCCESS');
export const ENTITY_EDIT_SUCCESS = createActionName('ENTITY_EDIT_SUCCESS');
export const ENTITY_USER_ADD_SUCCESS = createActionName('ENTITY_USER_ADD_SUCCESS');
export const ENTITY_USER_EDIT_SUCCESS = createActionName('ENTITY_USER_EDIT_SUCCESS');
export const GET_ENTITY_USERS_SUCCESS = createActionName('GET_ENTITY_USERS_SUCCESS');
export const DELETE_ENTITY_USERS_SUCCESS = createActionName('DELETE_ENTITY_USERS_SUCCESS');
export const DELETE_ENTITY_USERS_REQUEST = createActionName('DELETE_ENTITY_USERS_REQUEST');
export const ENTITY_SEARCH_SUCCESS = createActionName('ENTITY_SEARCH_SUCCESS');
export const GET_ENTITY_USERS_REQUEST = createActionName('GET_ENTITY_USERS_REQUEST');
export const USER_SEARCH_SUCCESS = createActionName('USER_SEARCH_SUCCESS');

export default function transaction(state = initialState, action) {
    let updatedEntity;
    let index;
    let entityList;

    switch (action.type) {
        case FETCHING_DATA:
            return {
                ...state,
                isFetching: action.status,
            };
        case SWITCH_LIST_SUCCESS:
            return {
                ...state,
                switchUsersList: action.data,
            };
        case ENTITY_LIST_SUCCESS:
            return {
                ...state,
                list: action.currentPage > 1 ? state.list.concat(action.data) : action.data,
                entityUsers: null,
                totalPages: action.totalPages,
                totalCount: action.totalCount,
            };
        case ENTITY_SEARCH_SUCCESS:
            return {
                ...state,
                list: action.currentPage > 1 ? state.list.concat(action.data) : action.data,
                entityUsers: null,
                totalPages: action.totalPages,
                totalCount: action.totalCount,
            };
        case ENTITY_FETCH_SUCCESS:
            return {
                ...state,
                entity: action.data,
                actorsAndRoles: action.data.actorsAndRoles,
                credpoolRoles: action.data.credpoolRoles,
            };
        case ENTITY_ADD_SUCCESS:
            return {
                ...state,
                list: [...state.list, action.data],
                entity: action.data,
            };
        case ENTITY_EDIT_SUCCESS:
            // replace updated entity with current entity list
            updatedEntity = action.data;
            entityList = state.list;
            index = entityList.findIndex((e) => e.id === updatedEntity.id);

            entityList.splice(index, 1, updatedEntity);

            return {
                ...state,
                list: entityList,
                entity: updatedEntity,
            };
        case GET_ENTITY_USERS_SUCCESS: {
            return {
                ...state,
                entityUsers: action.currentPage > 1 && state.entityUsers ? [...state.entityUsers, ...action.data] : action.data,
                totalPages: action.totalPages,
                totalCount: action.totalCount,
            };
        }
        case USER_SEARCH_SUCCESS:
            return {
                ...state,
                entityUsers: action.currentPage > 1 ? state.entityUsers.concat(action.data) : action.data,
                totalPages: action.totalPages,
                totalCount: action.totalCount,
            };

        case ENTITY_USER_ADD_SUCCESS:
            return {
                ...state,
                entityUsers: [...state.entityUsers, action.data],
            };
        case ENTITY_USER_EDIT_SUCCESS:
            // replace updated entity with current entity list
            updatedEntity = action.data;
            entityList = state.entityUsers;
            index = entityList.findIndex((e) => e.id === updatedEntity.id);
            if (index < 0) {
                entityList = [...entityList, action.data];
            } else {
                const newEntity = [...entityList];
                newEntity.splice(index, 1, action.data);
                entityList = [...newEntity];
            }

            return {
                ...state,
                entityUsers: entityList,
            };
        case DELETE_ENTITY_USERS_REQUEST:
            return {
                ...state,
                deleting: true,
            };
        case DELETE_ENTITY_USERS_SUCCESS:
            entityList = state.entityUsers.filter((item) => {
                if (item.id !== action.res.id) return item;
            });
            return {
                ...state,
                entityUsers: entityList,
                deleting: false,
            };
        default:
            return state;
    }
}

export function fetchingData(status = true) {
    return {
        type: FETCHING_DATA,
        status,
    };
}

export function fetchingEntityData() {
    return {
        type: GET_ENTITY_USERS_REQUEST,
    };
}

export const actorRoleNormalizer = (data, group) => {
    const camelizedData = humps.camelizeKeys(data);
    return camelizedData.map((m) => {
        const grp = Object.keys(m)[0];
        const sourceGroup = group ? Object.keys(group) : [];
        const sourceValues = group ? Object.values(group) : [];
        let selectedRoles = '';
        const roleObj = {};
        m[grp].forEach((n) => {
            roleObj[n] = sourceGroup.includes(grp) && sourceValues.includes(n);
            if (sourceGroup.includes(grp) && sourceValues.includes(n)) {
                selectedRoles = n;
            }
        });
        if (!selectedRoles) selectedRoles = 'admin';
        return {
            group: { [grp]: sourceGroup.includes(grp) },
            roles: roleObj,
            selectedRoles,
        };
    });
};

const actorRoleDenormalizer = (data, key = 'actorRoles') => {
    const groups = {};
    data[key].forEach((m, i) => {
        const a = Object.keys(m.group)[0];
        if (m.group[a] && m.selectedRoles.length > 0) {
            groups[a] = m.selectedRoles;
        }
    });
    return groups;
};

/** FIXME: All users are of admin role by default */
const mapEntityUser = (data) => {
    const d = {
        ...data,
        groups: actorRoleDenormalizer(data),
        notification_channels:
            (data.notificationChannelsVal && Object.keys(data.notificationChannelsVal).filter((c) => data.notificationChannelsVal[c])) || [],
        credpoolRoles: actorRoleDenormalizer(data, 'credpoolRoles'),
    };
    if (!_get(d, 'notification_channels', []).includes(NOTIFICATION_CHANNELS.EMAIL)) {
        d.notification_channels = _get(d, 'notification_channels', []).filter((n) => n !== NOTIFICATION_CHANNELS.TRANSACTION_RELATED);
    } else {
        if (!_get(d, 'notification_channels', []).includes(NOTIFICATION_CHANNELS.TRANSACTION_RELATED)) {
            d.notification_channels.push(NOTIFICATION_CHANNELS.TRANSACTION_RELATED);
        }
    }
    delete d.actorRoles;
    delete d.notificationChannelsVal;
    return {
        user: humps.decamelizeKeys(d),
    };
};

const unMapEntityUser = (data) => humps.camelizeKeys(data);

const unMapEntities = (entities) =>
    entities.map((e) => {
        const { CIN, actors } = e;
        const d = humps.camelizeKeys(omit(e, ['CIN', 'actors']));
        return { ...d, CIN, actors };
    });

const mapEntity = (entity) => {
    const dcEntity = humps.decamelizeKeys(omit(entity, ['logo', 'CIN']));
    const { logo = null, CIN } = entity;
    let formData = {
        ...dcEntity,
    };
    if (_get(dcEntity, 'address.line1')) {
        formData = {
            ...formData,
            address: {
                ...dcEntity.address,
                line_1: dcEntity.address.line1,
            },
        };
    }
    return logo ? objectToFormData({ entity: { ...formData, logo, CIN } }) : objectToFormData({ entity: { ...formData, CIN } });
};

const unMapEntity = (entity) => {
    const d = humps.camelizeKeys(omit(entity, ['logo', 'CIN', 'actors']));
    const { CIN, actors, credpool_roles } = entity;
    return {
        ...d,
        CIN,
        createdAt: moment(d.createdAt).format('DD MMM, YYYY'),
        actors: actors,
        credpoolActors: credpool_roles,
        actorsAndRoles: humps.camelizeKeys(actorRoleNormalizer(actors)),
        credpoolRoles: actorRoleNormalizer(credpool_roles),
    };
};

export function addEntity(entity) {
    return (dispatch) => {
        dispatch(fetchingData());
        return fetchUtils
            .postFormData(`${process.env.REACT_APP_MP_API_HOST}/entities`, mapEntity(entity))
            .then((d) => {
                dispatch(fetchingData(false));
                toastr.success('Success!', 'Entity added successfully');
                return dispatch({ type: ENTITY_ADD_SUCCESS, data: unMapEntity(d) });
            })
            .catch((ex) => {
                dispatch(fetchingData(false));
                fetchUtils.handleErrorV2(dispatch, ex).then((m) => {
                    toastr.error('Error adding entity', m);
                });
            });
    };
}

export function editEntity(entity) {
    return (dispatch) => {
        dispatch(fetchingData());
        return fetchUtils
            .putFormData(`${process.env.REACT_APP_MP_API_HOST}/entities/${entity.id}`, mapEntity(entity))
            .then((d) => {
                dispatch(fetchingData(false));
                toastr.success('Success!', 'Entity updated successfully');
                return dispatch({ type: ENTITY_EDIT_SUCCESS, data: unMapEntity(d) });
            })
            .catch((ex) => {
                dispatch(fetchingData(false));
                fetchUtils.handleErrorV2(dispatch, ex).then((m) => {
                    toastr.error('Error adding entity', m);
                });
            });
    };
}

export function searchUsers(entityId, user) {
    const userObj = { ...user };
    return (dispatch) =>
        fetchUtils
            .getJSON(`${process.env.REACT_APP_MP_API_HOST}/users/search?email=${user.email}`)
            .then((d) => {
                if (d.users.length > 0) {
                    userObj.id = d.users[0].id;
                    dispatch(editEntityUser(entityId, userObj));
                } else {
                    dispatch(addEntityUser(entityId, userObj));
                }
            })
            .catch((ex) => {
                console.error(ex);
                toastr.error('Error fetching user information', '');
            });
}

export function addEntityUser(entityId, user) {
    return (dispatch) => {
        dispatch(fetchingData());
        return fetchUtils
            .postJSON(`${process.env.REACT_APP_MP_API_HOST}/entities/${entityId}/users`, mapEntityUser(user))
            .then((d) => {
                dispatch(fetchingData(false));
                dispatch(getAllUserEntities());
                toastr.success('Success!', 'User is added successfully');
                return dispatch({ type: ENTITY_USER_ADD_SUCCESS, data: unMapEntityUser(d) });
            })
            .catch((ex) => {
                dispatch(fetchingData(false));
                fetchUtils.handleErrorV2(dispatch, ex).then((m) => {
                    toastr.error('Error adding user', m);
                });
            });
    };
}

export function editEntityUser(entityId, user) {
    return (dispatch) => {
        dispatch(fetchingData());
        return fetchUtils
            .patchJSON(`${process.env.REACT_APP_MP_API_HOST}/entities/${entityId}/users/${user.id}`, mapEntityUser(user))
            .then((d) => {
                dispatch(fetchingData(false));
                dispatch(getAllUserEntities());
                toastr.success('Success!', 'User is updated successfully');
                return dispatch({ type: ENTITY_USER_EDIT_SUCCESS, data: unMapEntityUser(d) });
            })
            .catch((ex) => {
                dispatch(fetchingData(false));
                fetchUtils.handleErrorV2(dispatch, ex).then((m) => {
                    toastr.error('Error adding user', m);
                });
            });
    };
}

export function manageEmailNotifications(entityId, userId, userData, callBack) {
    return (dispatch) => {
        dispatch(fetchingData());
        return fetchUtils
            .patchJSON(`${process.env.REACT_APP_MP_API_HOST}/entities/${entityId}/users/${userId}`, humps.decamelizeKeys(userData))
            .then((d) => {
                dispatch(fetchingData(false));
                dispatch(getAllUserEntities(callBack));
                toastr.success('Success!', 'Email notifications updated successfully');
            })
            .catch((ex) => {
                dispatch(fetchingData(false));
                fetchUtils.handleErrorV2(dispatch, ex).then((m) => {
                    toastr.error('Error updating Email notifications', m);
                });
            });
    };
}

export function deleteEntityUser(entityId, userId) {
    return (dispatch) => {
        dispatch({ type: DELETE_ENTITY_USERS_REQUEST });
        fetchUtils
            .deleteJSON(`${process.env.REACT_APP_MP_API_HOST}/entities/${entityId}/users/${userId}`)
            .then((res) => {
                toastr.success('Success!', 'User deleted successfully');
                return dispatch({ type: DELETE_ENTITY_USERS_SUCCESS, res });
            })
            .catch((ex) => {
                fetchUtils.handleErrorV2(dispatch, ex).then((m) => {
                    toastr.error('Error Deleting user', m);
                });
            });
    };
}

export function loadEntities(page = 1, search = '') {
    return (dispatch) => {
        dispatch(fetchingData());
        return fetchUtils
            .getJSON(`${process.env.REACT_APP_MP_API_HOST}/entities?page=${page}${search ? `&search=${search}` : ''}`)
            .then((d) => {
                dispatch(fetchingData(false));
                dispatch({
                    type: ENTITY_LIST_SUCCESS,
                    data: unMapEntities(d.entities),
                    totalPages: d.total_pages,
                    totalCount: d.total_count,
                    currentPage: page,
                });
            })
            .catch((ex) => {
                dispatch(fetchingData(false));
                fetchUtils.handleErrorV2(dispatch, ex).then((m) => {
                    toastr.error('Error loading entities', m);
                });
            });
    };
}

export function fetchEntity(id) {
    return (dispatch) =>
        fetchUtils
            .getJSON(`${process.env.REACT_APP_MP_API_HOST}/entities/${id}`)
            .then((d) => dispatch({ type: ENTITY_FETCH_SUCCESS, data: unMapEntity(d) }))
            .catch((ex) => {
                dispatch(fetchingData(false));
                fetchUtils.handleErrorV2(dispatch, ex).then((m) => {
                    toastr.error('Error fetching entity', m);
                });
            });
}

export function getEntityUsers(id, page = 1, search = '') {
    return (dispatch) => {
        dispatch(fetchingData());
        dispatch(fetchingEntityData());
        return fetchUtils
            .getJSON(`${process.env.REACT_APP_MP_API_HOST}/entities/${id}/users?page=${page}${search ? `&search=${search}` : ''}`)
            .then((d) => {
                dispatch(fetchingData(false));
                dispatch({
                    type: GET_ENTITY_USERS_SUCCESS,
                    data: unMapEntities(d.users),
                    totalPages: d.total_pages,
                    totalCount: d.total_count,
                    currentPage: page,
                });
            })
            .catch((ex) => {
                dispatch(fetchingData(false));
                fetchUtils.handleErrorV2(dispatch, ex).then((m) => {
                    toastr.error('Error fetching entity', m);
                });
            });
    };
}

export function searchEntity(page = 1, search = '') {
    return (dispatch) => {
        dispatch(fetchingData());
        return fetchUtils
            .getJSON(`${process.env.REACT_APP_MP_API_HOST}/entities?page=${page}${search ? `&search=${search}` : ''}`)
            .then((d) => {
                dispatch(fetchingData(false));
                dispatch({
                    type: ENTITY_SEARCH_SUCCESS,
                    data: unMapEntities(d.entities),
                    totalPages: d.total_pages,
                    totalCount: d.total_count,
                    currentPage: page,
                });
            })
            .catch((ex) => {
                dispatch(fetchingData(false));
                fetchUtils.handleErrorV2(dispatch, ex).then((m) => {
                    toastr.error('Error loading entities', m);
                });
            });
    };
}

function mapSwitchUsersList(data) {
    if (data && (!data.allEntities || data.allEntities.length < 1 || !Array.isArray(data.allEntities))) return [];
    const result = data.allEntities.map((m) =>
        Object.keys(m.groups).map((n) => ({
            name: m.companyName,
            entity_id: m.entityId,
            group: n,
            role: m.groups[n],
        })),
    );
    return flattenDeep(result);
}

export function getAllUserEntities(callBack) {
    return (dispatch) =>
        fetchUtils
            .getJSON(`${process.env.REACT_APP_AUTH_API_HOST}/entities/${getActiveEntityId()}/users/${getActiveUserId()}?product_id=${PRODUCT_ID}`)
            .then((d) => mapSwitchUsersList(humps.camelizeKeys(d)))
            .then((d) => {
                const activeGroup = Auth.getActiveUserGroup();
                const activeEntity = d.find((entity) => {
                    if (activeGroup) {
                        return entity.entity_id === activeGroup.entity_id && entity.group === humps.camelize(activeGroup.group);
                    }
                    return {};
                });
                Auth.setActiveUserGroup(activeEntity);
                dispatch({ type: SWITCH_LIST_SUCCESS, data: d });
                if (typeof callBack === 'function') callBack();
            })
            .catch((ex) => {
                dispatch(fetchingData(false));
                fetchUtils.handleErrorV2(dispatch, ex).then((m) => {
                    toastr.error('Error Retrieving Users', m);
                    if (typeof callBack === 'function') callBack();
                });
            });
}

const getUser = (entityId, id) => {
    return fetchUtils
        .getJSON(`${process.env.REACT_APP_AUTH_API_HOST}/entities/${entityId}/users/${id}?product_id=${PRODUCT_ID}`)
        .then((d) => humps.camelizeKeys(d))
        .catch(() => {
            toastr.error('Sorry!', 'Error fetching permissions!');
        });
};

export function fetchUser(entityId, id) {
    return fetchUtils.getJSON(`${process.env.REACT_APP_AUTH_API_HOST}/entities/${entityId}/users/${id}?product_id=${PRODUCT_ID}`).then((r) => {
        const profile = humps.camelizeKeys(r);
        setProfile({ ...profile, id: profile.caUserId });
        return profile;
    });
}

const getPermissions = (entityId, id) => {
    const { group } = Auth.getActiveUserGroup();

    return fetchUtils
        .getJSON(
            `${process.env.REACT_APP_AUTH_API_HOST}/users/${id}/all_permissions_web?product_id=${PRODUCT_ID}&entity_id=${entityId}&group_id=${group}`,
        )
        .then((d) => humps.camelizeKeys(d))
        .catch(() => {
            toastr.error('Sorry!', 'Error fetching user!');
        });
};

const getCRAPermissions = (entityId, id) => {
    const { group } = Auth.getActiveUserGroup();

    return fetchUtils
        .getJSON(
            `${process.env.REACT_APP_AUTH_API_HOST}/users/${id}/all_permissions_web?product_id=${PRODUCT_ID_CREDIT}&entity_id=${entityId}&group_id=${group}`,
        )
        .then((d) => humps.camelizeKeys(d))
        .catch(() => {
            toastr.error('Sorry!', 'Error fetching user!');
        });
};

export function fetchUserWithpermissions(entityId, id) {
    const { isInvestor, isProduct, isClient } = getActiveUser();
    const canFetchCRA = isInvestor || isProduct || isClient;

    return Promise.all([getUser(entityId, id), getPermissions(entityId, id), ...(canFetchCRA ? [getCRAPermissions(entityId, id)] : [])]).then((d) => {
        const profile = {
            ..._get(d, '[0]', {}),
            permissions: _get(d, '[1].permissions', {}),
            craPermissions: canFetchCRA ? _get(d, '[2].permissions', {}) : {},
        };
        setProfile({ ...profile, id: profile.caUserId });
        return profile;
    });
}

export function searchUser(id, page = 1, search = '') {
    return (dispatch) => {
        dispatch(fetchingData());
        return fetchUtils
            .getJSON(`${process.env.REACT_APP_MP_API_HOST}/entities/${id}/users?page=${page}${search ? `&search=${search}` : ''}`)
            .then((d) => {
                dispatch(fetchingData(false));
                dispatch({
                    type: USER_SEARCH_SUCCESS,
                    data: unMapEntities(d.users),
                    totalPages: d.total_pages,
                    totalCount: d.total_count,
                    currentPage: page,
                });
            })
            .catch((ex) => {
                dispatch(fetchingData(false));
                fetchUtils.handleErrorV2(dispatch, ex).then((m) => {
                    toastr.error('Error loading users', m);
                });
            });
    };
}

export function resendActivationLink(id, callback) {
    return (dispatch) => {
        return fetchUtils
            .patchJSON(`${process.env.REACT_APP_AUTH_API_HOST}/users/${id}/resend_activation_link?product_id=${PRODUCT_ID}`)
            .then((d) => {
                toastr.success('Success!', 'Reactivation mail sent successfully');
                if (typeof callback === 'function') callback();
            })
            .catch((ex) => {
                fetchUtils.handleErrorV2(dispatch, ex).then((m) => {
                    toastr.error('Error sending re-activation mail', m);
                    if (typeof callback === 'function') callback();
                });
            });
    };
}
